<template>
  <SoPageWithRightSidePanel v-model="current.isSidePanelCollapsed">
    <div v-if="!current.spaygEligibility.isFetched">
      <SoSkeleton :height="64" />
      <SoSkeleton :type="['list-item-three-line', 'button']" :height="320" />
    </div>
    <SpaygView v-else />
    <template #sidePanel>
      <CustomerAccountInfoPanel></CustomerAccountInfoPanel>
    </template>
    <template #sidePanelRail>
      <CustomerAccountInfoRail></CustomerAccountInfoRail>
    </template>
  </SoPageWithRightSidePanel>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { useSnackbarStore } from "@/stores/snackbar"
  import SoPageWithRightSidePanel from "@/components/templates/SoPageWithRightSidePanel.vue"
  import CustomerAccountInfoPanel from "../overview/CustomerAccountInfoPanel.vue"
  import CustomerAccountInfoRail from "../overview/CustomerAccountInfoRail.vue"
  import SoSkeleton from "@/components/SoSkeleton.vue"
  import SpaygView from "./flows/spayg/SpaygView.vue"

  export default defineComponent({
    components: {
      SoPageWithRightSidePanel,
      CustomerAccountInfoPanel,
      CustomerAccountInfoRail,
      SoSkeleton,
      SpaygView,
    },
    data() {
      return {
        snackbar: useSnackbarStore(),
        current: useCurrentAccountStore(),
      }
    },
  })
</script>
